import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'shared-link-container',
  imports: [IconComponent, RouterLink],
  templateUrl: './link-container.component.html',
  styleUrl: './link-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex-column relative' },
})
export class LinkContainerComponent {
  @Input() headline: string | undefined;
  @Input() showHeadline = true;
  @Input() link: string | string[] | undefined;
  @Input() subCardLink: string | string[] | undefined;
  @Input() queryParams: Params | undefined;
  @Input() contentStyleClass: string | undefined;
  @Input() isActive = false;
  @Input() showArrowIcon = false;
  @Input() subCardClass: string | undefined;
}
